import mixpanel from "mixpanel-browser";

// Records employee info on login
export const trackCommunication = (agency: string, permitTypeName: string, permitNumber: string) => {
  try {
    // Send information to Mixpanel
    mixpanel.track("Permit Communication Message Sent", {
      "site": agency,
      "Permit Type": permitTypeName,
      "Permit Number": permitNumber,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
